import React, { useState } from "react";
import { Tooltip, Box } from "@mui/material";
import { useTheme } from "../theme/useTheme";

export const InfoTooltip = ({ title, placement = "top", size = 16, sx = {}, zIndex, children }) => {
  const { theme } = useTheme();
  const [open, setOpen] = useState(false);
  const popperSx = zIndex
    ? {
        zIndex: `${zIndex} !important`,
        "&.MuiPopper-root": {
          zIndex: `${zIndex} !important`,
        },
      }
    : undefined;
  const popperStyle = zIndex ? { zIndex } : undefined;
  const iconSx = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: size,
    height: size,
    minWidth: size,
    borderRadius: "50%",
    border: `1.5px solid ${theme.palette.text.secondary}`,
    color: theme.palette.text.secondary,
    fontSize: Math.max(size * 0.7, 10),
    fontWeight: 700,
    lineHeight: 1,
    boxSizing: "border-box",
    flexShrink: 0,
  };
  
  if (!children) {
    return (
      <Tooltip 
        title={title} 
        arrow 
        placement={placement}
        slotProps={{ popper: { sx: popperSx, style: popperStyle } }}
        PopperProps={{ sx: popperSx, style: popperStyle }}
      >
        <Box 
          component="span"
          sx={{ 
            display: "inline-flex", 
            alignItems: "center", 
            cursor: "help", 
            ...sx 
          }}
        >
          <Box component="span" aria-hidden="true" sx={iconSx}>
            ?
          </Box>
        </Box>
      </Tooltip>
    );
  }

  return (
    <Box 
      component="span"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onClick={() => setOpen(!open)}
      sx={{ 
        display: "inline-flex", 
        alignItems: "center", 
        gap: 0.75,
        cursor: "help", 
        lineHeight: 1,
        ...sx 
      }}
    >
      {children}
      <Tooltip 
        title={title} 
        arrow 
        placement={placement} 
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        slotProps={{ popper: { sx: popperSx, style: popperStyle } }}
        PopperProps={{ sx: popperSx, style: popperStyle }}
      >
        <Box component="span" aria-hidden="true" sx={iconSx}>
          ?
        </Box>
      </Tooltip>
    </Box>
  );
};
